import { useEffect, useState } from 'react';

import sharesTitlesStatus from 'modules/partners/pages/TitleRegistryBook/constants/sharesTitlesStatus';
import { Share, SharesTitle } from 'types';
import { getTitleByShare } from '../utils/getTileByShare';

type Props = {
  share: Share;
  sharesTitles: SharesTitle[];
};
const CANCELLED_STATUS = sharesTitlesStatus[2].value;

export const useGetShareTitle = ({ share, sharesTitles }: Props) => {
  const [sharesTitle, setSharesTitle] = useState<SharesTitle | null>(null);
  const [titleWatermarkText, setTitleWatermarkText] = useState<string>('');

  useEffect(() => {
    const title = getTitleByShare(sharesTitles, share);

    if (title) {
      setSharesTitle(title);
      const titleWatermarkText =
        title?.status === CANCELLED_STATUS ? 'TÍTULO CANCELADO' : '';

      setTitleWatermarkText(titleWatermarkText);
    } else {
      setSharesTitle(null);
    }
  }, [share, sharesTitles]);

  return { data: { sharesTitle, titleWatermarkText } };
};
